import toast from 'react-hot-toast';
import { useTranslation } from 'react-i18next';
import { PRODUCT_DISCOUNTS_LIST_KEY, PRODUCT_DISCOUNTS_ONE_KEY } from '../constants';
import { ProductDiscountService } from '../services';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { OFFER_STATUS } from 'modules/sales-offer/common/constants/offer.enum';

const useUpdateProductDiscountEnabled = (offerId: string, onClose?: () => void) => {
  const { t } = useTranslation(['productDiscount', 'errors']);
  const queryClient = useQueryClient();

  return useMutation(
    (status: OFFER_STATUS) => ProductDiscountService.updateStatus(offerId, status === OFFER_STATUS.ACTIVE),
    {
      onSuccess: (data: any, variables) => {
        toast.success(
          t('successChangedStatus', {
            status: t(`enabledTypes.${variables}`),
          }),
        );
        queryClient.invalidateQueries({ queryKey: [PRODUCT_DISCOUNTS_LIST_KEY] });
        queryClient.invalidateQueries({ queryKey: [offerId, PRODUCT_DISCOUNTS_ONE_KEY] });
        onClose?.();
      },
      onError: () => {
        toast.error(t('generalErrorMessage', { ns: 'errors' }));
      },
    },
  );
};

export default useUpdateProductDiscountEnabled;
